import React, { Fragment, useEffect, useState } from 'react';
import styles from '../../styles.module.css';
import Api from '@/api';
import Checkbox from '@/components/common/CheckBox';
import FilterBlock from '../FilterBlock';
import { attributeType } from '@/commonTypes';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';

export default function AttributeFilter({ page = '/products' }: { page?: string }) {
  const [attributeList, setAttributeList] = useState<attributeType[]>([]);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (page == '/products') {
      Api.attributeList()
        .then((res) => {
          setAttributeList(res?.data?.response);
        })
        .catch((err) => {
          console.error('attributeList failed:', err);
        });
    } else {
      // api call for service attributes
    }
  }, []);

  const chooseAttribute = (slug?: string, value?: string) => {
    const params = new URLSearchParams(searchParams.toString());

    const key = `attr[${slug}]`;

    const current = params.get(key)?.split(',').filter(Boolean) || [];

    let updated;

    if (value && current.includes(value)) {
      // remove
      updated = current.filter((x) => x !== value);
    } else {
      // add
      updated = [...current, value];
    }

    if (updated.length) {
      params.set(key, updated.join(','));
    } else {
      params.delete(key);
    }
    params.set('page', '1');
    router.replace(`${pathname}?${params.toString()}`);
  };
  console.log('attributeList====', attributeList);
  return (
    <>
      {attributeList?.map((item, index) => (
        <Fragment key={index}>
          {item?.options?.length != 0 && (
            <FilterBlock title={item?.name}>
              <div key={item.slug} className={`${styles.filter_list}`}>
                {item?.options?.map((x, j) => (
                  <div key={j} className={`${styles.singleCategory}`}>
                    <Checkbox
                      title={x?.value}
                      checked={
                        searchParams.get(`attr[${item.slug}]`)?.split(',').includes(x?.value) ||
                        false
                      }
                      onChange={() => {
                        chooseAttribute(item?.slug, x?.value);
                      }}
                      titleClass={`${styles.Check_label}`}
                    />
                  </div>
                ))}
              </div>
            </FilterBlock>
          )}
        </Fragment>
      ))}
    </>
  );
}
